import { SensorType } from '../../types/sensor-type';
import { BaseSensorWebComponent } from '../../base/BaseSensorWebComponent';
import { GCPSensorController } from '../controller/GCPSensorController';

export class GCPSensorComponent extends BaseSensorWebComponent {
  public controller!: GCPSensorController;

  constructor() {
    super();
    this.sensorType = SensorType.GCP;
    this.initialSetup({
      controllerConstructor: GCPSensorController,
    });
  }

  public setEnabled(isEnabled: boolean): void {
    this.controller.setEnabledAllFields(isEnabled);
  }
}
